import { useFlags } from "launchdarkly-react-client-sdk";

const useModuleFlag = (moduleKey, subModuleKey, type = "boolean") => {
  const flags = useFlags();

  if (type === "boolean") {
    return flags[moduleKey] ?? false;
  } else {
    return flags[moduleKey]?.[subModuleKey] ?? false;
  }
};

export default useModuleFlag;
